import flow from 'lodash/flow';
import ShowroomTab from 'src/pages/ShowroomTab/ShowroomTab';

export default flow(
)(ShowroomTab);
